import type { FaireProductEntity } from "../../entity_types/product";

export const p_8hfcq593am: FaireProductEntity = {
  token: "p_8hfcq593am",
  type: "product",
  name: "Dark Chocolate Donuts 8-Pack (VE, GF, K, No Sugar, Soy-Free)",
  brandToken: "b_d3ssphc04o",
  brandName: "Planet Bake",
  imageUrl:
    "https://cdn.faire.com/fastly/7a2c94cfe76a256b7b055d33d445f9b017870c0d5be58f19d8c54949d9344dde.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7268a025b355e4b426d7e85dd80d91e1e57515364efff7ddb7a26a95048e31c4.png",
    "https://cdn.faire.com/fastly/f91ffdd08417f86003526b87923cd233a989ab69a1c044f1f192d591ba6d2016.png",
    "https://cdn.faire.com/fastly/f1f15e2a6cb33975487e14061346a52fd27d28023cf11bfbdb612a4818b85e66.png",
    "https://cdn.faire.com/fastly/31aea92f0fbffe50fafab74a4cefb328af03f3540d50ae38ad2c6f39d5f43ad2.png",
    "https://cdn.faire.com/fastly/12c34941f084e9152a84105618aae6cb4df027cbd1550a423638f7d3bce0f396.png",
    "https://cdn.faire.com/fastly/2f6cc90702885a19ad752a9dfce637b75e53b19161559260c354280dca618d23.png",
    "https://cdn.faire.com/fastly/f07f1c6ac80c672a73543ea08ebd4885c21cefee3147573d84545b97ad4e53cb.png",
  ],
  priceDollars: 32.7,
  description:
    "\n\n\nBENEFITS?\n\n\n✓ VEGAN ✓ GLUTEN FREE ✓ NO ADDED SUGAR ✓ 5g NET CARBS ✓ NON GMO INGREDIENTS ✓ FIBER ✓ SOY FREE ✓ KOSHER ✓ CLEAN INGREDIENTS ✓ WOMEN-OWNED\n\nDelight in decadence guilt-free with our Vegan, Sugar-Free Dark Chocolate Frosted Donuts. Crafted with premium cacao superfoods, these indulgent treats redefine the essence of chocolatey bliss.\n\nSavor the rich, semi-sweet dark chocolate flavor, expertly curated from the finest cacao beans. Each bite offers a luxurious experience, accentuated by a dense yet moist texture that melts in your mouth.\n\n\nElevate your snacking experience with our Dark Chocolate Donuts, a celebration of flavor and wholesomeness. Indulge in the richness of dark chocolate, minus the guilt, and embark on a journey of pure satisfaction with every delectable bite\n\n*Nutrition Information can be found in the images! \n\nAllergens?\n\n\nCONTAINS TREE NUTS\n\n\n\n\n*See packaging for more information!\n\n",
  tags: [],
  msrpDollars: 65.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:19.282Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
